import React, { FC, useEffect } from 'react'
import Button from 'react-bootstrap/Button'
import { useHistory } from 'react-router'
import useLogoutUser from '../../hooks/authentication/useLogoutUser'
import useUserWithRole from '../../hooks/authentication/useUserWithRole'
import isAuthenticated from '../../routes/PrivateRoute'
import Jumbotron from '../Jumbotron'
import PageTitle from '../PageTitle'

const AccessDenied: FC = () => {
  const { user, removeUser } = useUserWithRole()

  const logoutUser = useLogoutUser()
  const history = useHistory()
  const handleLogoutUser = () => {
    logoutUser.mutate({ refreshToken: user.refresh_token })
  }

  useEffect(() => {
    if (logoutUser.isSuccess) {
      removeUser()
      history.push('/login')
    }
  }, [logoutUser.isSuccess])

  return (
    <Jumbotron>
      <PageTitle displayName="Access Denied" />
      <h1 className="display-5 mb-3 h2">Access Denied</h1>
      <p>
        It looks like the member associated with this account has recently turned 18 and as the owner you have lost access to view their data.
      </p>
      <Button
        variant="primary"
        type="button"
        onClick={handleLogoutUser}
      >
        Go Back
      </Button>
    </Jumbotron>
  )
}

export default isAuthenticated(AccessDenied)
